module.exports = __webpack_public_path__ + "img/big.587516dc.jpg";